<template>
    <b-container fluid class="d-flex flex-column mh-100 h-100 no-gutters py-0 w-100 overflow-auto">
        <b-row class="w-100 no-gutters py-0">
            <!-- Gestion des périodes -->
            <MultiPeriod :ref="$id('multiPeriod')" :Configs.sync="configs" :Variant="Variant" :Errors.sync="errorList" />
        </b-row>
        <b-row class="w-100 no-gutters py-0 accordion">
            <!--<Label class="font-weight-bold py-1 p-2 mx-0 w-100 bg-white" v-if="configs.Data.length == 0">
                Cliquer sur un nœud de l’arborescence pour sélectionner un objectif.
            </Label>
            <template v-else>-->
            <!-- Affichage des DataBlocks et du bouton d'ajout -->
            <b-row class="w-100 no-gutters py-0 accordion">
                <b-button @click="checkedAddGoal()" :disabled="dataBlocks?.length >= 1"
                          v-b-tooltip.hover
                          :title="dataBlocks?.length >= 1 ? $t('OnlyOneGoal') : ''"
                          class="mx-2 font-weight-semibold" :variant="'outline-' + Variant" pill>
                    <b-icon icon="plus-lg" scale="0.8"/>
                    {{ $t('NewGoal') }}
                </b-button> <!-- devra être supprimé -->

                <DataBlockGoal v-for="(dataBlock, index) in dataBlocks" :key="index"
                               :Index="index + 1"
                               :DataValue="dataBlocks[index]"
                               :Variant="Variant"
                               @RemoveDataBlockEvent="removeData(index)"
                               @ChangeConfigCommonWorkDataEvent="changeConfigCommonWorkData(index)"/>
            </b-row>
            <!--</template>-->
        </b-row>


        <!-- Pour l'affichage des objectifs -->
        <b-modal :visible="visible" no-close-on-backdrop centered size="lg" :variant="Variant">
            <template #modal-header="{close}">
                <b-col class="text-center">
                    <!-- v-html pour prise en compte balises HTML -->
                    <h6><p v-html="$t('SimpleGoalSearch')"></p></h6> <!-- Recherche Objectif <b>Simple</b> -->
                </b-col>
                <b-col md="auto" class="text-right">
                    <b-icon-x-lg role="button" font-scale="1" @click="visible = false; close();" v-b-tooltip.hover
                                 :title="$t('Close')"/>
                </b-col>
            </template>
            <b-row class="pb-2 px-3">
                <b-input-group>
                    <b-form-input
                        v-model="searchValue"
                        autofocus
                        @keydown.enter="executeSearch();"
                        :placeholder="$t('PleaseEnterYourSearch')"/>
                    <template #append>
                        <b-button @click="executeSearch();" :variant="Variant">{{ $t('ToSearch') }}</b-button>
                    </template>
                </b-input-group>
            </b-row>
            <b-alert v-if="results.length == 0 && error" show variant="danger">{{ $t('NoResult') }}</b-alert>
            <template v-if="results.length > 0">
                <b-row class="p-2" :style="generateVariantStyle(Variant)">
                    <b-form-checkbox-group :id="$id('selectedGoals')" v-model="selectedGoals" name="selectedGoals">

                        <b-table :id="$id('goalItems')" selectable select-mode="multi" sort-desc :items="results"
                                 :fields="searchFields" :no-select-on-click="visible"
                                 :per-page="itemPerPage" :current-page="currentPage">
                            <!-- Cellule permettant la sélection d'éléments via une case à cocher -->
                            <template #cell(Id)="key">
                                <b-form-checkbox :value="key.value" name="" class="m-0 selectedGoal"
                                                 :disabled="selectedGoals.length == 1 && selectedGoals[0] != key.value"
                                                 v-b-tooltip.hover
                                                 :title="selectedGoals.length >= 1 ?
                                     $t('OnlyOneGoalSelected') : ''"/> <!-- 'Il n\'est possible de sélectionner qu\'un seul objectif pour l\'instant' -->
                            </template>
                            <template #cell(NodeType)="type">
                                <b-img :src="AbsoluteLink('Icons/' + type.value + '_Icon.svg')" height="20rem"
                                       width="20rem"/>
                            </template>
                            <template #cell(IsBench)="data">
                                <template v-if="data.value">
                                    <b-icon icon="diagram3" font-scale="1.5"/>
                                </template>
                                <template v-else>
                                    <b-icon icon="calculator" font-scale="1.5"/>
                                </template>
                            </template>

                        </b-table>
                    </b-form-checkbox-group>
                </b-row>
            </template>
            <template #modal-footer>
                <b-col>
                    <b-pagination v-if="results.length > 0" v-model="currentPage" :total-rows="results.length"
                                  :per-page="itemPerPage" class="mr-auto" :style="generateVariantStyle(Variant)"/>
                </b-col>
                <b-col md="auto">
                    <b-button @click="visible = false; close();" :variant="'outline-' + Variant" pill
                              class="ml-auto m-2">{{ $t('Close') }}
                    </b-button>
                    <b-button @click="validSelection()" :disabled="!(selectedGoals.length > 0 && results.length > 0)"
                              :variant="Variant" pill class="ml-auto">{{ $t('Validate') }}
                    </b-button>
                </b-col>
            </template>
        </b-modal>
    </b-container>
</template>

<script lang="ts">
import {Component, Vue, Watch} from 'vue-property-decorator';
import ModeEnum from "@/enums/ModeEnum";
import BasePeriod from "@/types/Config/BasePeriod";
import Range from "@/types/Config/Range";
import moment from "moment/moment";
import Sliding from "@/types/Config/Sliding";
import DateToDate from "@/types/Config/DateToDate";
import GoalData from "@/types/Config/GoalData";
import {mixins} from "vue-class-component";
import FeatureConfigWData from "@/components/commons/Config/FeatureConfigWData";
// import PeriodConfig from './Periods/PeriodConfig';
import Dictionary from "@/types/Dictionary";
import {API_URL} from "@/App.settings";
import axios from "axios";
import DataBlockGoal from "@/components/commons/Config/FeatureConfigWData/DataBlockGoal.vue";
import {LinkUtils, ThemeUtils} from "@/components/commons/Utils";
import data from "@/types/Config/Data";
import Data from "@/types/Config/Data";
import MultiPeriod from './Periods/MultiPeriod.vue';
/** Traductions */
import locales from './locales/Goal.json';

/**
 *  Paramétrage de la fonction Objectif
 *  @description Hérite de FeatureConfig et non de FeatureConfigWData car elle ne gère pas de bloc de données
 * */
@Component({
    computed: {
        data() {
            return data
        }
    },
    components: {
        DataBlockGoal, 
        MultiPeriod
    },
    i18n : { messages : locales }
})
export default class Goal extends mixins(FeatureConfigWData<GoalData>, LinkUtils, ThemeUtils) {

    /** Permet de vérifier la validité des différents champs obligatoires */
    public CheckInvalidity(): boolean {
        let periodInvalid: boolean = false;
        let typeInvalid: boolean = false;

        // Vérification de l'invalidité de la période
        if(this.$id("multiPeriod") in this.$refs && this.$refs[this.$id("multiPeriod")] && typeof (this.$refs[this.$id("multiPeriod")] as any).CheckPeriodsInvalidity === "function")
                periodInvalid = (this.$refs[this.$id("multiPeriod")] as any).CheckPeriodsInvalidity();

        typeInvalid = this.dataBlocksInvalidity((dataBlock: Data) => {
            return dataBlock.Type == "";
        });

        console.debug("Goal - CheckInvalidity - isInvalid", typeInvalid || periodInvalid);

        return typeInvalid || periodInvalid;
    }

    //#region Masque de configuration

    /** Permet de charger les périodes du masque de configuration */
    @Watch('SelectedMask')
    private loadMask() {
        if(this.$id("multiPeriod") in this.$refs && this.$refs[this.$id("multiPeriod")] && typeof (this.$refs[this.$id("multiPeriod")] as any).loadPeriods === "function")
                (this.$refs[this.$id("multiPeriod")] as any).loadPeriods(this.SelectedMask["Parameters"]);
    }

    /** Enregistrement du Mask pour Goal */
    public SaveMask(): Dictionary<any> {
        let parametersValues: Dictionary<any> = {};

        parametersValues.Periods = this.configs["Periods"];
        parametersValues.Feature = this.configs["Feature"];
        parametersValues.Data = this.configs["Data"];

        return parametersValues;
    }

    //#endregion Masque de configuration

    /** Génération du titre */
    public GenerateTitle(): string {
        let title: string = this.GetDataBlocksTitle();
        
        if(this.$id("multiPeriod") in this.$refs && this.$refs[this.$id("multiPeriod")] && typeof (this.$refs[this.$id("multiPeriod")] as any).GeneratePeriodsTitle === "function")
            title += (this.$refs[this.$id("multiPeriod")] as any).GeneratePeriodsTitle();

        return title;
    }

    //#region Partie Recherche d'un objectif
    private currentPage: number = 1;
    private itemPerPage: number = 8;
    private error: boolean = false;
    public visible: boolean = false;

    /** Element sélectionné dans le tableau */
    public selectedGoals: any[] = [];

    public TypesList!: [];

    /** Valeur de recherche */
    private searchValue: string = "";

    /** Tableau des résultats */
    private results: any[] = [];

    /** Tableau des entêtes du tableau */
    private searchFields = [
        {key: "Id", label: "", ThStyle: "width:20px"},
        {key: "IsBench", label: "", thStyle: "width:20px", sortable: false},
        {key: "Name", label: this.$t('Title').toString(), sortable: true}, // "Intitulé"
        {key: "GoalName", label: this.$t('GoalName').toString(), sortable: true}, // "Intitulé objectif"
        {
            key: "Units", label: this.$t('Unit').toString(), sortable: true, formatter: value => { // "Unité"
                return value.join('/');
            }
        },
        {key: "NodeType", label: "", sortable: false},
        {key: "NodeInvariant", label: this.$t('Invariant').toString(), sortable: true},
        {key: "NodeName", label: this.$t('Name').toString(), sortable: true} // "Nom"
    ]

    /** Validation de la sélection  */
    private validSelection() {
        console.debug("Goal - validSelection - this.selectedGoals", this.selectedGoals, this.configs, this.configs.Data?.length == 1 && this.configs.Data[0].GoalId == undefined);

        if (this.configs.Data.length == 1 && this.configs.Data[0].GoalId == undefined) {
            this.removeData(0);
        }

        let goalIsBench = this.dataBlocks?.findIndex(a => a.Goal?.IsBench);
        if (goalIsBench > -1) {
            this.$bvToast.toast(this.$t('CantSelectSimpleAndGroupedGoal').toString(), { //  "Il n'est pas possible de sélectionner des objectifs regroupés et non regroupés ensemble."
                title: this.$t('NoSelectionPossible').toString(), // "Sélection impossible"
                autoHideDelay: 10000,
                variant: "warning",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
            return false;
        }

        for (let i = 0; i < this.selectedGoals.length; i++) {
            let goal = this.results.find(a => a.Id == this.selectedGoals[i]);

            if (goal.IsBench && this.dataBlocks?.length > 1) {
                this.$bvToast.toast(this.$t('CantSelectSimpleAndGroupedGoal').toString(), { // "Il n'est pas possible de sélectionner des objectifs regroupés et non regroupés ensemble."
                    title: this.$t('NoSelectionPossible').toString(), // "Sélection impossible",
                    autoHideDelay: 10000,
                    variant: "warning",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return false;
            }

            /* TODO : À voir pourquoi valeur à null ? */
            let id = this.getNewId();
            if (id == null)
                id = 1;
            console.debug("Goal - validSelection - id", id);

            this.newData({
                Id: id,
                GoalId: this.selectedGoals[i],
                Goal: undefined,
                Cumulate: false,
                AddedColumns: []
            });
        }
        // On remet à 0 les nœuds sélectionnés après chaque recherche
        this.results = [];
        this.selectedGoals = [];
        this.searchValue = '';
        this.visible = false;
    }

    /** Vérifie s'il est possible d'ajouter un objectif */
    private checkedAddGoal() {
        let goalIsBench = this.dataBlocks?.find(a => a.Goal?.IsBench);
        if (goalIsBench != undefined) {
            this.$bvToast.toast(this.$t('OnlyOneGroupedGoal').toString(), { // "Il est possible de ne sélectionner qu'un seul objectif regroupé."
                title: this.$t('NoSelectionPossible').toString(),
                autoHideDelay: 10000,
                variant: "warning",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
            return false;
        } else {
            this.executeSearch();
        }

        this.visible = true;
        return true;
    }

    /**
     * Fonction pour filtrer les éléments du tableau dans le b-table
     * @param filteredItems liste des éléments filtrés selon la valeur recherchée
     */
    private onFiltered(filteredItems) {
        this.currentPage = 1;
    }

    /** Execute la recherche et récupère les résultats */
    private executeSearch() {

        // Ecran de chargement
        this.$store.dispatch("ShowLoadingMask", this.$t('SearchInProgress')); // "Recherche en cours"

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Value"] = this.searchValue;
        if (this.configs.Pins.length > 0 && this.configs.Pins[0].Value > 0) {
            args["NodeId"] = this.configs.Pins[0].Value[0];
        }

        axios.post(API_URL + 'Goals/Search', args).then((response) => {
            if (response && response.data) {
                console.debug("Goal - executeSearch - axiosResult", response.data);

                this.results = response.data.Goals;

                // On remet à 0 les nœuds sélectionnés après chaque recherche
                this.selectedGoals = [];

                if (this.results.length > 0)
                    this.currentPage = 1;
                else
                    this.error = true;
            }
            this.$store.dispatch("HideLoadingMask", {})
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast( this.$t('AnErrorOccuredContactAdmin').toString(), { // "Une erreur est survenue. Veuillez contacter votre administrateur."
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });
    }

    //#endregion Partie Recherche d'un objectif

    mounted() {
        console.debug("Goal - mounted - configs ", this.configs);

        /** Initialisation des DataBlocks */
        this.init(undefined, (dataBlock) => {
            return (dataBlock.GoalId != '');
        })
    }
}

class GoalPeriod {
    SelectedMode: ModeEnum;
    SelectedPeriod: string;
    Duration: number;
    LastYearPeriod: BasePeriod;
    RefPeriod: BasePeriod;
    SelectedYears: { value: number }[];
    SelectedMonths: { month: string, year: number }[];
    SelectedWeeks: { week: number, year: number }[];
    SelectedDays: { start: string, end: string }[];
    SelectedHours: { start: string, startHour: string, end: string, endHour: string }[];
    TimeUnit: { Id: string, Label: string };
}
</script>

<style scoped lang="scss">
/**
Fichier .css à importer pour toutes les fonctions d'Analysis (Evolution, Goal, ...)
*/
@import './analysis.scss';

/* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
:deep(.custom-control-input:checked ~ .custom-control-label::before) {
    border-color: var(--Variant) !important;
    background-color: var(--Variant) !important;
}

/* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
:deep(.custom-control-input:active ~ .custom-control-label::before) {
    background-color: var(--Variant) !important;
    border-color: var(--Variant) !important;
}

:deep(.selectedGoal>.custom-control-input) {
    opacity: 1;
}

/** Pour que la page active prenne en compte la couleur de Variant */
:deep(.page-item.active .page-link) {
    background-color: var(--Variant) !important;
}

:deep(.page-link:hover) {
    background-color: var(--VariantLight) !important;
}
</style>